/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Why_Listening_Insights_Overview_BodyInputs */

const en_why_listening_insights_overview_body = /** @type {(inputs: Why_Listening_Insights_Overview_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A short summary of the whole document.`)
};

const es_why_listening_insights_overview_body = /** @type {(inputs: Why_Listening_Insights_Overview_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un breve resumen de todo el documento.`)
};

/**
* | output |
* | --- |
* | "A short summary of the whole document." |
*
* @param {Why_Listening_Insights_Overview_BodyInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const why_listening_insights_overview_body = /** @type {((inputs?: Why_Listening_Insights_Overview_BodyInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Why_Listening_Insights_Overview_BodyInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_why_listening_insights_overview_body(inputs)
	return en_why_listening_insights_overview_body(inputs)
});